import React, { useEffect, useState } from 'react'
import './index.scss'
import { ProjectType } from '@utils/types'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import { FadeInSection } from '@components/Animations'

type Props = {
  project: ProjectType
}

const GalleryItem = ({ project }: Props) => {
  const [isHovered, setHovered] = useState(false)

  const handleOnMouseOver = () => {
    if (project?.hoverImage?.asset) setHovered(false)
  }

  const handleOnMouseLeave = () => {
    setHovered(false)
  }

  return (
    <div className="grid-item">
      <FadeInSection timeout={250}>
        <Link to={`/projects${project?.slug?.current}`}>
          {project?.mainImage?.asset?.gatsbyImageData && (
            <GatsbyImage
              onMouseOver={handleOnMouseOver}
              onMouseLeave={handleOnMouseLeave}
              className="gallery-image"
              image={
                isHovered
                  ? project?.hoverImage?.asset?.gatsbyImageData
                  : project?.mainImage?.asset?.gatsbyImageData
              }
              alt={
                isHovered ? project?.hoverImage?.alt : project?.mainImage?.alt
              }
              imgStyle={{ objectFit: 'contain' }}
            />
          )}
          <div className="project-info">
            <h5>{project?.title}</h5>
            <p>{project?.category}</p>
          </div>
        </Link>
      </FadeInSection>
    </div>
  )
}

export default GalleryItem
